"use client";

import { useEffect, useRef } from "react";

const highlights = [
  {
    icon: "🌬️",
    title: "Bem Ventilado",
    description: "Climatização de alta qualidade e ventilação natural em todos os espaços para máximo conforto durante as aulas.",
  },
  {
    icon: "🏛️",
    title: "Espaço Dedicado",
    description: "Ambientes exclusivos para cada modalidade — sala de Pilates, sala de terapias e recepção acolhedora.",
  },
  {
    icon: "⚙️",
    title: "Equipamentos Modernos",
    description: "Reformers, Cadillac, Chair e acessórios de última geração das melhores marcas do mercado.",
  },
  {
    icon: "🌿",
    title: "Ambiente Confortável",
    description: "Design biofílico com elementos naturais, iluminação suave e acústica cuidadosa para promover bem-estar.",
  },
];

export default function EnvironmentHighlights() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.remove("reveal-hidden");
            e.target.classList.add("reveal-active");
          }
        });
      },
      { threshold: 0.08 }
    );
    ref?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-24 px-6 md:px-10 bg-cream" ref={ref}>
      <div className="max-w-8xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {highlights?.map((item, i) => (
            <div
              key={item?.title}
              className={`reveal-hidden reveal-delay-${i + 1} bg-white rounded-4xl p-8 text-center group transition-all duration-500 hover:-translate-y-2`}
              style={{
                boxShadow: '0 2px 16px rgba(26,61,26,0.06), 0 8px 32px rgba(26,61,26,0.04)',
                border: '1px solid rgba(232,226,214,0.5)',
              }}
            >
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center text-2xl mx-auto mb-6 group-hover:scale-110 transition-transform duration-300"
                style={{ background: 'var(--gold-pale)', border: '1px solid rgba(201,168,76,0.25)' }}
              >
                {item?.icon}
              </div>
              <h3 className="font-serif mb-3" style={{ fontSize: '1.2rem', color: 'var(--forest)' }}>{item?.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: 'var(--stone)' }}>{item?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}